/**
 * @mynaui/icons-react v0.3.1 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var CalendarUp = createReactComponent("calendar-up", "CalendarUp", [["path", { "d": "M16.5 5V3m-9 2V3M3.25 8h17.5m-8.747 9.5L12 12.22m2.5 1.933L12 11.5l-2.5 2.653", "key": "svg-0" }], ["path", { "d": "M3 10.044c0-2.115 0-3.173.436-3.981a3.896 3.896 0 0 1 1.748-1.651C6.04 4 7.16 4 9.4 4h5.2c2.24 0 3.36 0 4.216.412.753.362 1.364.94 1.748 1.65.436.81.436 1.868.436 3.983v4.912c0 2.115 0 3.173-.436 3.981a3.896 3.896 0 0 1-1.748 1.651C17.96 21 16.84 21 14.6 21H9.4c-2.24 0-3.36 0-4.216-.412a3.896 3.896 0 0 1-1.748-1.65C3 18.128 3 17.07 3 14.955z", "key": "svg-1" }]]);

export { CalendarUp as default };
//# sourceMappingURL=CalendarUp.js.map
